import React from 'react';
import './style.css';

const Divider = () => {
  return <hr className="divider" />;
};

export default Divider;
